import type { TMessages } from '@/types/TMessages'

export const messages = { header: 'Лучшие предложения, чтобы продать урожай' } satisfies TMessages
